import(/* webpackMode: "eager" */ "/app/components/SearchPanelCards.js")